export class ServiceDataPutUserPermissionSetting {
    formData;
    constructor(data) {
        this.formData = data;
    }
    createReqBody() {
        const requestDataList = this.formData.userMenuAuthorities.map(({ code, isAuthorized, }) => ({
            code,
            isAuthorized,
        }));
        const requestData = {
            userMenuAuthorities: requestDataList,
        };
        return requestData;
    }
}
